import axios from "axios";
import { API_HOST } from "@/core/variables";
import { Scene } from "@/model";
import { escapeCondition } from "@/util/stringUtil";


class SceneRepository {
    create = async (scenarioId: string, scene: Partial<Scene>) => {
        const response = await axios.post(
            `${API_HOST}/scenario/${scenarioId}/scenes`,
            scene
        );
        return response.data;
    };

    find = async (scenarioId: string, condition?: string) => {
        const searchCondition = escapeCondition(condition);

        const response = await axios.get(
            `${API_HOST}/scenario/${scenarioId}/scenes`,
            {
                params: { condition: searchCondition }
            }
        );
        return response.data;
    };

    updateScenes = async (scenarioId: string, formData: FormData) => {
        const response = await axios.put(
            `${API_HOST}/scenario/${scenarioId}/scenes`,
            formData,
            {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }
        );
        return response.data;
    };

    deleteScene = async (scenarioId: string, sceneId: number) => {
        const response = await axios.delete(
            `${API_HOST}/scenario/${scenarioId}/scenes/${sceneId}`
        );
        return response.data;
    };
}

const sceneRepository = new SceneRepository();

export default sceneRepository;
